import { constants, coreActions, coreStore, dataServices, polyfillPromise, Promise } from '@ambita/ambita-components-core';
import UserApi from 'infoland-components/api/UserApi';
import { fetchConfig } from './envConfig';

polyfillPromise();

const { core: coreConstants } = constants;

const loadAppCode = (): PromiseLike<any> => {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['../app'],
      (require: any): void => {
        const app = require('../app');
        resolve(app);
      },
      (error: any) => {
        reject(error);
      },
      'app'
    );
  });
};

const loadConfig = (): Promise<void> => {
  return fetchConfig().then((config) => {

    return new Promise((resolve) => {
      coreStore.on(coreConstants.TOKEN_NOT_FOUND_EVENT, UserApi.loginAnonymous);
      coreStore.once(coreConstants.USER_CHANGE_EVENT, resolve);

      const coreSettings = {
        environment: config.environment,
        language: 'nb',
        clientId: dataServices.config.CLIENT_ID_INFOLAND,
        mapProductsEnabled: true,
        linkProductsEnabled: true,
        ownershipReportProductEnabled: true,
        isNorgesEiendommerNewEnabled: config.isNorgesEiendommerNewEnabled,
        isAdvancedRegistrationFlowEnabled: config.isAdvancedRegistrationFlowEnabled,
        isAdvancedCreditCardRegistrationFlowEnabled: config.isAdvancedCreditCardRegistrationFlowEnabled
      };

      coreActions.changeSettings(coreSettings);
    });
  });
};

export const bootstrap = (): void => {
  loadConfig()
    .then(loadAppCode)
    .then(app => app.initialize());
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./app/config/bootstrap.ts